import "./svg/nav-search-filled.svg"

export default {
    name: "nav-search-filled",
    viewBox: "24 24",
}
